
<template>
  <div class="process black">
    <div class="layout-content">
      <SubTitle class="title" :text="data.title" subText="FINTECHATHON" />
      <div class="content-img-wrap">
        <img
          v-if="!isMobile"
          class="content-img"
          :src="require('../../assets/img/rules/role-process-web.png')"
        >
        <template v-else>
          <img
            class="content-img"
            :src="require('../../assets/img/rules/schedule_mobile_up.png')"
          >
          <div class="dowload-word" @click="dowloadFile">「队伍信息表模版下载」</div>
          <img
            class="content-img"
            :src="require('../../assets/img/rules/schedule_mobile_down.png')"
          >
        </template>
        <div v-if="!isMobile" class="dowload-word" @click="dowloadFile">「队伍信息表模版下载」</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SubTitle from '@/components/SubTitle'

export default {
  props: ['data'],
  data () {
    return {

    }
  },
  components: {
    SubTitle
  },

  computed: {
    ...mapState([
      'isMobile'
    ])
  },

  methods: {
    dowloadFile () {
      window.open('https://static001.geekbang.org/static/biz/file/webank/%E9%98%9F%E4%BC%8D%E4%BF%A1%E6%81%AF%E8%A1%A8%E6%A8%A1%E7%89%88.xlsx')
    }
  }
}
</script>

<style lang="scss" scoped>

.process {
  padding: 80px 0 100px;
  background: url('https://static001.geekbang.org/resource/image/4f/43/4f42500ed8c1d24f205d1bd690a1ac43.png') center / cover no-repeat;

  @include mobile {
    padding: 0;
    background: #F7F8FA;
  }
}
.content-img-wrap {
  position: relative;
}
.dowload-word {
  position: absolute; left: 157px; top: 508px;
  font-size: 16px; color: #2859fb;
  text-decoration: underline;
  cursor: pointer;

  @include mobile {
    position: relative;
    left: calc(5vw + 10px); top: 0;
    font-size: 14px;
  }
}

.content-img {
  width: 100%;
  @include mobile {
    width: 100%; height: auto;
    vertical-align: middle;
  }
}
</style>
